import { createAction } from 'redux-actions';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const REDIRECT_TO_FAST_SEARCH = 'REDIRECT_TO_FAST_SEARCH';
export const submitForm = createAction(SUBMIT_FORM, (onSubmit) => onSubmit);
export const redirectToFastSearch = createAction(REDIRECT_TO_FAST_SEARCH);
